import { Modal, StackModalProps } from 'almanac-ui/Modal'
import { Button } from 'components/Button'

interface NotificationModalProps extends StackModalProps {
  title: string
  message: string
}

export const NotificationModal = ({ close, title, message }: NotificationModalProps) => {
  return (
    <Modal.Root size="xs">
      <Modal.Header title={title} size="sm" />
      <Modal.Content>
        <p>{message}</p>
      </Modal.Content>
      <Modal.Footer>
        <Modal.FooterContent slot="right">
          <Button variant="primary" size="lg" onPress={close}>
            OK
          </Button>
        </Modal.FooterContent>
      </Modal.Footer>
    </Modal.Root>
  )
}
